// extracted by mini-css-extract-plugin
module.exports = {"formPanel":"ContributionForm_formPanel__mKlNm","success":"ContributionForm_success__1XkEc","error":"ContributionForm_error__mpkOu"};